// extracted by mini-css-extract-plugin
export default {"modalContainer":"Modal_modalContainer__6tscA","fadeIn":"Modal_fadeIn__IFgTP","ovarlay":"Modal_ovarlay__bxYAI","closeButton":"Modal_closeButton__nb0DB"};